import { render } from "./Shop.vue?vue&type=template&id=3aade096&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=3aade096&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3aade096"

export default script